import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';
import { MatDialog } from '@angular/material/dialog';
import { GbpLocationMappingModalComponent } from './location-mapping-modal.component';

@Component({
  selector: 'app-gbp-locations-list',
  templateUrl: './locations-page.component.html',
  styleUrls: ['./locations-page.component.css'],
})
export class GbpLocationsListComponent implements OnInit {
  url: string = 'gbpLocations';
  data: Array<any> = [];
  searchText = '';
  filteredData: Array<any> = [];

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/observability/seo/metricsDaily',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/observability/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/observability/social',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'MEDIAROOM',
      route: '/observability/mediaroom',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'LOGISTICS',
      route: '/observability/logistics',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-receipt',
      bgClass: 'bg-white',
      desc: 'ACCOUNTING',
      route: '/observability/accounting',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-coins',
      bgClass: 'bg-white',
      desc: 'FINANCE',
      route: '/observability/finance',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'HR',
      route: '/observability/hr',
    },
  ];

  constructor(
    private dataService: DataService,
    private messageService: MessageService,
    private dialog: MatDialog,
    public router: Router,
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    this.dataService.getData(this.url).subscribe((response) => {
      if (response && response.rst) {
        console.log('response', response);
        this.data = response.data;
        this.filter();
      } else {
        this.messageService.add(
          response.msg || 'Error loading locations',
          'danger',
        );
      }
    });
  }

  filter() {
    const texto = this.searchText.trim().toLowerCase();
    if (!texto) {
      this.filteredData = [...this.data];
    } else {
      this.filteredData = this.data.filter((item) => {
        return (
          (item.title && item.title.toLowerCase().includes(texto)) ||
          (item.address && item.address.toLowerCase().includes(texto)) ||
          (item.gbpLocationName &&
            item.gbpLocationName.toLowerCase().includes(texto))
        );
      });
    }
  }

  editMapping(location: any) {
    const dialogRef = this.dialog.open(GbpLocationMappingModalComponent, {
      width: '500px',
      data: { location: { ...location } },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getData();
      }
    });
  }

  toggleStatus(location: any) {
    const newStatus = location.status === 'active' ? 'inactive' : 'active';
    const body = {
      status: newStatus,
      mapping: location.mapping,
    };

    this.dataService
      .putData(`${this.url}/mapping/${location._id}`, body)
      .subscribe((res) => {
        if (res.rst) {
          location.status = newStatus;
          // this.messageService.add('Status updated', 'success');
        }
      });
  }
}
